<template>
  <div class="property-banner">
    <img :src="mobilepropertyBanner" alt="" />
    <div class="absolute">
      <div class="title">物业APP</div>
      <div class="text">
        一机在手，满足物业在线协同管理，实现物业服务模式升级，助力物业智能化，提升业主满意度，构建智慧社区。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/mobile/components/Experience.vue";

import mobilepropertyBanner from "../../../../assets/product/mobilepropertyBanner.png";

export default {
  setup() {
    return reactive({
      mobilepropertyBanner: mobilepropertyBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.property-banner {
  position: relative;
}
.property-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #fff;
}
.absolute .text {
  font-size: 12px;
  margin-top: 10px;
  color: #fff;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 20px;
  color: #fff;
  border: 1px solid #fff;
  text-align: center;
  cursor: pointer;
   width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
